module.exports = __webpack_public_path__ + "static/media/ic_save.262bb9e7.svg";